import axiosTuri from "../../axiosTuri";

const axiosBaseQuery =
  ({ baseUrl } = { baseUrl: "" }) =>
  async ({ url, method, data, body, params, headers }) => {
    // This line is correct, it prioritizes `body` from mutations.
    const requestData = body || data;

    // --- THIS IS THE CRUCIAL FIX ---
    // 1. Create a mutable copy of the headers.
    const newHeaders = { ...headers };

    // 2. Check if the payload is FormData.
    if (requestData instanceof FormData) {
      // 3. If it is, DELETE the 'Content-Type' header.
      //    This is what allows the browser to correctly set the multipart header with its boundary.
      delete newHeaders["Content-Type"];
    }
    // --- END OF FIX ---

    try {
      const result = await axiosTuri({
        url: baseUrl + url,
        method,
        data: requestData,
        params,
        headers: newHeaders, // Use our corrected headers object
      });
      return { data: result.data };
    } catch (axiosError) {
      const err = axiosError;
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };

export default axiosBaseQuery;
